import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {message} from 'antd';
import {AxiosError, AxiosResponse} from 'axios';
import configService from './configServices';
import {CONFIG} from './config.type';

const initialState = {
  isLoading: false,
  config: {
    permissions: {
      add_employee: false,
      show_employee: false,
      add_permissiongroup: false,
      update_employee: false,
      show_permissiongroup: false,
      update_permissiongroup: false,
      add_stationgroup: false,
      show_stationgroup: false,
      update_stationgroup: false,
      add_station: false,
      show_station: false,
      update_station: false,
      add_chargercategory: false,
      show_chargercategory: false,
      update_chargercategory: false,
      add_charger: false,
      show_charger: false,
      update_charger: false,
      add_rackcategory: false,
      show_rackcategory: false,
      update_rackcategory: false,
      add_rack: false,
      show_rack: false,
      update_rack: false,
      add_batterycategory: false,
      show_batterycategory: false,
      update_batterycategory: false,
      add_battery: false,
      show_battery: false,
      update_battery: false,
    },
    is_admin: false,
    is_station_employee: false,
    config: {},
  } as CONFIG,
};

export const config = createAsyncThunk('config', async (payload, thunkAPI) => {
  try {
    const data: AxiosResponse = await configService.config();
    return data;
  } catch (error) {
    const result = error as AxiosError;
    return thunkAPI.rejectWithValue(result.message);
  }
});

export const userPasswordUpdate = createAsyncThunk(
  'userPasswordUpdate',
  async (payload: {password: string}, thunkAPI) => {
    try {
      const data: AxiosResponse = await configService.userPasswordUpdate(payload);
      return data;
    } catch (error) {
      const result = error as AxiosError;
      return thunkAPI.rejectWithValue(result.message);
    }
  },
);

export const configSlice = createSlice({
  name: 'auth',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(config.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(config.fulfilled, (state, action) => {
      state.isLoading = false;
      state.config = action.payload.data;
    });
    builder.addCase(config.rejected, (state, action) => {
      state.isLoading = false;
      state.config = initialState.config;
      message.error(`${action.payload}`);
    });

    builder.addCase(userPasswordUpdate.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(userPasswordUpdate.fulfilled, (state) => {
      state.isLoading = false;
      message.success('Password updated successfully');
    });
    builder.addCase(userPasswordUpdate.rejected, (state, action) => {
      state.isLoading = false;
      state.config = initialState.config;
      message.error(`${action.payload}`);
    });
  },
});

export default configSlice.reducer;
